export default {
  paper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '5px',
    backgroundColor: '#fff!important',
  },
  wrapper: (minWidth) => ({
    '& .MuiInputLabel-root[data-shrink="true"]': {
      top: 0,
      color: (theme) => theme.palette.grays.gray300,
    },

    '& .MuiAutocomplete-root': {
      padding: 0,
      '& .MuiOutlinedInput-root': {
        paddingTop: '9px',
      },
    },
    '& .MuiAutocomplete-listbox': {
      padding: '4px',
      margin: 0,
    },
    '& .MuiAutocomplete-popper': {
      minWidth,
    },
    '& .MuiAutocomplete-paper': {
      backgroundColor: '#fff',
    },
    '& .MuiPaper-root': {
      boxShadow: 'none',
    },
    '& .MuiAutocomplete-clearIndicator': {
      svg: { width: '14px' },
      color: (theme) => theme.palette.grays.gray700,
      '&:hover': {
        background: 'none',
      },
    },
  }),
  autocomplete: {
    width: '100%',
    color: (theme) => theme.palette.grays.gray700,
    backgroundColor: '#fff',

    '& .MuiOutlinedInput-root': {
      padding: '10px 65px 10px 12px !important',
      height: '40px',
    },
    '.MuiAutocomplete-popupIndicator': {
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '::after': {
        content: '""',
      },
    },
  },
  selectItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '6px 12px !important',
    cursor: 'pointer',
    transition: 'background-color 0.15s',
    backgroundColor: 'transparent !important',
    borderRadius: '6px',
    marginBottom: '0 !important',
    fontSize: '0.875rem',
    fontWeight: 400,
    color: (theme) => `${theme.palette.text.primary} !important`,
    '&.Mui-focused': {
      backgroundColor: (theme) => `${theme.palette.grays?.gray100} !important`,
      color: (theme) => `${theme.palette.text.primary} !important`,
      span: {
        color: (theme) => `${theme.palette.text.primary} !important`,
      },
    },
    '&[aria-selected="true"]': {
      backgroundColor: (theme) => `${theme.palette.grays?.gray100} !important`,
      color: (theme) => `${theme.palette.text.primary} !important`,
      '&.Mui-focused': {
        backgroundColor: (theme) =>
          `${theme.palette.grays?.gray100} !important`,
        color: (theme) => `${theme.palette.text.primary} !important`,
        span: {
          color: (theme) => `${theme.palette.text.primary} !important`,
        },
      },
    },
    '&:hover': {
      backgroundColor: (theme) => `${theme.palette.grays?.gray100} !important`,
      color: (theme) => `${theme.palette.text.primary} !important`,
    },
  },
  radioIcon: {
    fontSize: '16px',
    color: (theme) => theme.palette.blues.primaryBlue500,
  },
  radioUncheckedIcon: {
    fontSize: '16px',
    color: (theme) => theme.palette.grays?.gray300,
  },
  endAdornmentWrapper: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    right: '9px',
    bottom: 0,
    top: 0,
  },

  icon: {
    cursor: 'pointer',
  },

  textfield: {
    width: '100%',
    height: '100%',
    fontSize: '0.875rem',
    padding: '0!important',

    '& .MuiSelect-nativeInput': {
      height: '100%',
    },
    '& .MuiInputBase-input': {
      padding: '0!important',
      fontSize: '0.875rem!important',
      color: (theme) => theme.palette.grays.gray700,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
    },

    '& .MuiInputBase-root': {
      '&:hover': {
        backgroundColor: (theme) => theme.palette.grays.lightestGray,

        '& .MuiOutlinedInput-notchedOutline': {
          border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
        },
      },
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: 1,
          borderColor: (theme) => `${theme.palette.grays.gray300}`,
          border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
        },
      },
      '&.Mui-error': {
        '.MuiOutlinedInput-notchedOutline': {
          boxShadow: (theme) => `${theme.customShadows.errorShadow}`,
          borderColor: (theme) => `${theme.palette.reds.codingRed200}`,
        },
        '&.Mui-focused': {
          backgroundColor: (theme) => `${theme.palette.grays.lightestGray}`,
        },
        '&:hover': {
          backgroundColor: (theme) => `${theme.palette.grays.lightestGray}`,
        },
      },
      '&.Mui-disabled': {
        opacity: 0.8,
        pointerEvents: 'none',
        '& .MuiInputBase-root': {
          pointerEvents: 'none',
        },
        '& .MuiInputBase-input': {
          backgroundColor: 'transparent',
          pointerEvents: 'none',
        },
      },
    },
  },
};
